/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export interface AddressComponentsWithId {
    place_name?: string;
    street_number?: string;
    street_name?: string;
    postcode?: string;
    ward?: string;
    district?: string;
    borough?: string;
    city?: string;
    country_subdivision?: string;
    country?: string;
    country_code?: string;
    region?: string;
    region_code?: string;
    fallback_address?: string;
    fallback_address_extra?: string;
    fallback_full_address?: string;
    place_id: string;
}
